import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MyTreeNode } from '../objects/TreeviewObject';
import { DetailProperty, ValueSelection } from '../objects/DetailObject';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DetailService } from '../services/detail.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { ThemeSetting } from '../objects/ThemeObject';

@Component({
  selector: 'app-hierarchy-view',
  templateUrl: './hierarchy-view.component.html',
  styleUrls: ['./hierarchy-view.component.css']
})
export class HierarchyViewComponent implements OnInit, AfterViewInit {

  private selectedId: string;
  private currentTerm: string;
  private finalFilteredList:MyTreeNode[] = [];
  private finalVisibleList:MyTreeNode[] = [];
  private currentDataSource: MyTreeNode[];
  private fullDataSource: MyTreeNode[];
  private indeterminate: boolean = false;
  private expandList:string[] = [];
  private slice: boolean = false;
  private fullData: any;
  private currentPage: number = 1;
  loaderConfig: any;
  isBusy: boolean;
  errorMessage: string;
  isVirtualScroll: boolean = true;
  matTreeDataSource: MatTreeNestedDataSource<MyTreeNode>;
  treeControl: NestedTreeControl<MyTreeNode>;
  searchFilter: Subject<string> = new Subject<string>();

  @Input() set treeDataSource(tree: MatTreeNestedDataSource<MyTreeNode>){
    this.matTreeDataSource = tree;
    //this.currentDataSource = this.matTreeDataSource.data;
    this.fullDataSource = this.matTreeDataSource.data;
    
    this.expandList.forEach(id => {
      this.findNodesById(id);
    });

    if (this.currentTerm){
      this.expandAllIfHasChild();
      // this.treeControl.expandAll();
    }
    this.isBusy = false;
    //if (this.isVirtualScroll) this.matTreeDataSource.data = this.fullDataSource.slice(0, 10);
  }
  @Input() set setTreeControl(tree: NestedTreeControl<MyTreeNode>){
    this.treeControl = tree;
  }
  @Input() hasSearch: boolean = false;
  @Input() hasChildren: any;
  @Input() hasCheckbox: boolean = false;
  @Input() viewMode: boolean = false;
  @Input() singleSelection: boolean;
  @Input() propertyName: string;
  @Input() fromSummary: boolean = false;
  @Input() set selectItem(id: string){
    this.selectedId = id;
    if (id){
      this.setSelectedNode(id);
    }
  }
  @Input() set setVirtualScroll(bool: boolean){
    this.isVirtualScroll = bool;
  }

  @Output() selectTree = new EventEmitter<any>();
  @Output() checkedNode = new EventEmitter<DetailProperty>();
  @Output() searchChanged = new EventEmitter<string>();
  @Output() expandNode = new EventEmitter<any>();
  @Output() loadMoreData = new EventEmitter<any>();

  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport; 

  constructor(private detailService: DetailService, private themeSettingService: ThemeSettingService) { }

  ngOnInit() {
    let themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
  }

  ngAfterViewInit() {
    if (this.isVirtualScroll){
      if (this.isVirtualScroll && !this.slice) {
        this.matTreeDataSource.data = this.fullDataSource.slice(0, 10);
        this.slice = true;
      }

      this.virtualScroll.renderedRangeStream.subscribe(range => {
        this.matTreeDataSource.data = this.fullDataSource.slice(range.start, range.end)
      })
    }
  }

  emit(node){
    if (!this.viewMode){
      this.selectTree.emit(node);
      if (this.selectedId){
        if (this.matTreeDataSource.data.find(x => x.id == this.selectedId)){
          this.matTreeDataSource.data.find(x => x.id == this.selectedId).isSelected = false;
        }
      }
      if (this.matTreeDataSource.data.find(x => x.id == node.id)){
       this.matTreeDataSource.data.find(x=> x.id == node.id).isSelected = true;
      }
      this.selectedId = node.id;
    }
  }

  setSelectedNode(id:string){
    if (this.matTreeDataSource){
      if (this.matTreeDataSource.data.find(x => x.id == id)){
        this.matTreeDataSource.data.find(x => x.id == id).isSelected = true;
      }
    }
  }

  onChangeNode(node:any){
    this.indeterminate = false;
    if (this.singleSelection){
      this.treeControl.dataNodes.forEach(node => {
        node.isSelected = false;
        if (node.children){
          this.recursiveFindChild(node);
        }
      })
    }
    else {
      // changed to all hierarchymultiselect, auto check the child
      if (node.children){
        this.recursiveFindChild(node, !node.isSelected, !node.isSelected); // find child
      }
    }
    
    node.isSelected = !node.isSelected; // set the correct current selected item
    this.checkedNode.emit(node);
  }

  recursiveFindChild(node: MyTreeNode, isSelected: boolean = false, isDisabled: boolean = false){
    node.children.forEach(child => {
      child.isDisabled = isDisabled;
      child.isSelected = isSelected;
      if (child.children) this.recursiveFindChild(child, isSelected, isDisabled);
    });
  }

  recursiveFindSelectedChild(node: MyTreeNode){
    if (node.children.filter(x => x.isSelected).length == node.children.length) {
      node.children.forEach(child => {
        if (child.children) this.recursiveFindSelectedChild(child);
      });
    }
    else{
      if (node.children.filter(x => x.isSelected).length > 0) node.indeterminate = true;
    }
  }

  findNodesById(id: string){
    // this will find through its level first, if not found, it will start to search through its child
    // condition to break the recursive loop :
    // 1. node is found
    // 2. node and all its descendants cannot find the selected node
    if(this.matTreeDataSource.data.filter(x => x.id == id).length > 0){
      this.treeControl.expand(this.matTreeDataSource.data.find(x => x.id == id));
      this.autoCheckChild(this.matTreeDataSource.data.find(x => x.id == id));
    }
    else{
      this.matTreeDataSource.data.forEach(element => {
        if (element.children) this.recursiveFindNodesById(id, element.children)
      });
    }
  }

  autoCheckChild(node: any){
    if (!this.singleSelection){
      if (node.children && node.isSelected){
        node.children.forEach(child => {
          child.isDisabled = true;
          child.isSelected = true;
        });
      }
    }
  }

  recursiveFindNodesById(id: string, treeNodes: MyTreeNode[]){
    if (treeNodes.filter(x => x.id == id).length > 0){
      this.treeControl.expand(treeNodes.find(x => x.id == id));
      this.autoCheckChild(treeNodes.find(x => x.id == id));
    }
    else{
      treeNodes.forEach(element => {
        if (element.children) this.recursiveFindNodesById(id, element.children)
      });
    }
  }
  
  expandAllIfHasChild(){
    this.matTreeDataSource.data.forEach(element => {
      this.recursiveExpandChild(element);
    });
  }

  recursiveExpandChild(element: MyTreeNode){
    if (element.children){
      if (element.children.length > 0) {
        this.treeControl.expand(element);
  
        element.children.forEach(child => {
          this.recursiveExpandChild(child);
        });
        
      }
    }
    
  }
  // filterChanged(term: any){
  //   this.searchFilter.next(term);

  //   var currentTerm: string;
  //   this.searchFilter.take(1).pipe(debounceTime(500), distinctUntilChanged())
  //   .subscribe(term => {
  //     if (term && term.length >= 3) {
  //       if (currentTerm != term){
  //         currentTerm = term;
  //         this.filterByName(term);
  //       }
  //     } else {
  //       this.clearFilter();
  //     }
  //   });
  // }

  toggleNode(isExpanded: boolean, node: MyTreeNode, event = null){
    if (isExpanded){
      if (!node.children){
        node.isLoading = true;
        if (this.expandList.filter(x => x == node.id).length == 0){
          this.expandList.push(node.id)
        }
        var object = {node: node, isExpanded: isExpanded};
        var newObject = JSON.parse(JSON.stringify(object));
        this.expandNode.emit(newObject);
      }
      else{
        if (node.children.length == 0) node.isLoading = true;
        
        if (this.expandList.filter(x => x == node.id).length == 0){
          this.expandList.push(node.id)
        }
        var object = {node: node, isExpanded: isExpanded};
        var newObject = JSON.parse(JSON.stringify(object));
        this.expandNode.emit(newObject);
      }
    }
    else{
      var index = this.expandList.indexOf(node.id);
      if (index > -1) {
        this.expandList.splice(index, 1);
      }
      else{
        if (node.children){
          if (!node.children.some(x => this.expandList.includes(x.id))){ // check whether element in one array is in another array
            this.expandList.splice(index, 1);
          }
        }
      }
    }
  }

  loadMore(){
    this.currentPage = this.currentPage + 1;
    this.detailService.setLoadMore({page: this.currentPage, name: this.propertyName});
  }

  public filter(event: any) {
    var term = event.target.value;
    if (term.length > 0 && term.length < 3) {
      this.errorMessage = "Make sure the search keyword is more than two characters";
      return;
    }
    else{
      this.errorMessage = "";
    }
    
    if (this.currentTerm != term){
      if (!term) this.expandList = [];
      this.isBusy = true;
      this.currentTerm = term;
      this.searchChanged.emit(term);
    }

    event.preventDefault();
    event.stopPropagation();
  }

  searchHierarchy(){
    // this.filterChanged.pipe(
    //   debounceTime(500),
    //   distinctUntilChanged(),
    //   tap((value) => {
    //     // this.isPropertyLoading = true
    //   }
    //   )
    // ).subscribe(result => {
    //   this.summaryService.setFilter(this.params);
    // })
  }
  
  private clearFilter(): void {
    this.matTreeDataSource.data = this.currentDataSource;
  }

}